export const styles = (theme) => ({
  root: {
    zIndex: 2,
  },
  logo: {
    maxWidth: "70%",
  },
  title: {
    color: "#55B849",
    fontWeight: "bold",
    fontSize: 24,
  },
  contact: {
    color: "white",
    fontSize: 18,
  },
});
